<nav class="navbar navbar-dark bg-dark mb-5">
  <div class="container-fluid">
      <span class="navbar-brand mb-0 h1">DEADLOCK,Inc.</span>
  </div>
</nav>
